import { UNIT_SYSTEM } from '../../../shared/config/hydraulics_constants';
import { DATAGRID_TABLE_CELL_WIDTH } from '../../../utils/constants';

const columns = (renderCell, renderActions, renderValueCell, bitDetails, currentUnit) => [
  {
    field: 'number',
    headerName: 'Number',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderCell,
    editable: false,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'size',
    headerName: `Size (${bitDetails?.nozzles?.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : value.toFixed(bitDetails?.nozzles?.decimals);
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    headerAlign: 'center',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    align: 'center',
    renderCell: renderActions,
  },
];
export default columns;
